import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApplicationDataService } from '../../services/application.service';
import { CognitoUtil } from '../../services/cognito.service';
import { Property } from '../models/property';
import { EventEmitterService } from 'services/event-emitter.service';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.css']
})

export class ApplicationComponent implements OnInit {
  propertyKey: string;
  model: Property = new Property();
  user: any;
  userFirstName = '';
  userInitials = '';
  authenticated = false;
  display: boolean = false;

  constructor(private router: Router, private applicationService: ApplicationDataService,
    private cognitoUtil: CognitoUtil, private eventEmitterService: EventEmitterService, private zone: NgZone ) {
    if (localStorage.getItem('UserFirstName') || localStorage.getItem('UserLastName')) {
      this.userFirstName = localStorage.getItem('UserFirstName');
      const userLastName = localStorage.getItem('UserLastName');
      this.userInitials = this.userFirstName.substr(0, 1) + userLastName.substr(0, 1);

    }
    
    this.user = this.cognitoUtil.getCurrentUser();
    try
    {
      this.user.getSession(this.getSession.bind(this));
      this.authenticated = true;
    }
    catch(e)
    {
    }

    this.eventEmitterService.propertyChangeEmitted$.subscribe(res => this.updateProperty(res))
   }

  ngOnInit() {
    const unitcode = localStorage.getItem('YardiKey');
    const mfUnitCode = localStorage.getItem('mfunitcode');

    if (unitcode && !localStorage.getItem('SelectedProperty')) {
      if(mfUnitCode != null){
        // MF prop
        this.applicationService.getMFProperty(unitcode, mfUnitCode).subscribe(res => this.onGetProperty(res.results)); 
      }else{
        // SF prop
        this.applicationService.getProperty(unitcode).subscribe(res => this.onGetProperty(res.results)); 
      }
    } else if (localStorage.getItem('SelectedProperty')) {
      const property = JSON.parse( localStorage.getItem('SelectedProperty'));
      this.model = property[0];
    }
  }

  onGetProperty(property: Property[]) {
    this.model = property[0];
    localStorage.setItem('SelectedProperty', JSON.stringify(property));
  }

  getSession(error, sessionData) {
    if (!error) {
      const providerType = localStorage.getItem("ProviderType");
      if(!providerType){
        this.user.getUserAttributes(this.getUserAttributes.bind(this));
      }
    }
  }

  getUserAttributes(err, attributes) {
    if (!err) {
      const fName = attributes.find(x => x.getName() === 'custom:FirstName').getValue();
      const lName = attributes.find(x => x.getName() === 'custom:LastName').getValue();
      if (fName) {
        this.userFirstName = fName;
        localStorage.setItem('UserFirstName', fName);
      }
      if (lName) {
        localStorage.setItem('UserLastName', lName);
      }

      this.userInitials = fName.substr(0, 1) + lName.substr(0, 1);
    }
  }

  updateProperty(model: any) {
    if (model.results[0] !== undefined)
    {    
      if (document.querySelector(".banner") !== null)
      {
        document.querySelector(".banner").className = "banner row";
        window.requestAnimationFrame(function(time) {
        window.requestAnimationFrame(function(time) {
          document.querySelector(".banner").className = "banner row banner-animation";
        });
      });
      }
      this.model = model.results[0]
      
    }
  }

  redirect(url: string)
  {
    this.router.navigate([url]);
  }
}
